module.exports = __webpack_public_path__ + "img/bx-11.e0b08f01.jpg";